import type { AllocationFailureMarker } from 'pages/marking/subpages/marking-allocation-tab/types';

// user: [UE-TIMR-1] User (CustomersUsers) already set as a marker on the TestInstanceResponse
function organisationUserAlreadyAddedToTestInstanceResponseMessage(): string {
  return 'Sorry, this user has already been allocated to the response.';
}

export default function friendlyFailureReason(unallocatedMarker: AllocationFailureMarker): string {
  const { failureReason } = unallocatedMarker;

  if (failureReason.includes('[UE-TIMR-1]')) {
    return organisationUserAlreadyAddedToTestInstanceResponseMessage();
  }

  return failureReason;
}
